import { motion } from "framer-motion";
import RichHtml from "@/components/RichHtml";
import VerseText from "@/components/VerseText";

export default function Salvation({ content }) {
  const steps = content?.steps || [];
  return (
    <section id="salvation" data-testid="salvation-section" className="py-24 lg:py-32 bg-[#F3EFEA] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#2C4C3B] mb-4">The good news</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-tight text-[#1C201E]">
            {content?.heading || "The Call to Salvation"}
          </h2>
          <div className="mt-6 text-[#5C6661] text-lg leading-relaxed">
            <RichHtml html={content?.intro} testId="salvation-intro" />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`salvation-step-${i}`}
              className="p-8 border border-[#E5E0D8] rounded-2xl bg-white shadow-sm"
            >
              <div className="text-xs uppercase tracking-[0.2em] text-[#D4A373]">Step {i + 1}</div>
              <h3 className="mt-2 font-serif-display text-3xl text-[#1C201E]">{s.title}</h3>
              <div className="mt-3 text-xs text-[#2C4C3B] font-semibold"><VerseText text={s.verse} /></div>
              <div className="mt-4 text-[#5C6661] leading-relaxed">
                <RichHtml html={s.text} />
              </div>
            </motion.div>
          ))}
        </div>

        {content?.prayer && (
          <div className="mt-16 p-10 rounded-3xl bg-white border border-[#E5E0D8] shadow-sm">
            <div className="text-xs uppercase tracking-[0.2em] text-[#2C4C3B] mb-4 font-semibold">A prayer of faith</div>
            <div className="font-serif-display text-2xl leading-relaxed italic text-[#1C201E]">
              <RichHtml html={content.prayer} testId="salvation-prayer" />
            </div>
            {content?.cta && <p className="mt-6 text-[#5C6661]">{content.cta}</p>}
          </div>
        )}
      </div>
    </section>
  );
}
